export const GET_PAGES_LIST_SAGA: string = "GET_PAGES_LIST_SAGA";
export const SET_PAGES_LIST: string = "SET_PAGES_LIST";
export const SET_PAGES_LIST_COUNT: string = "SET_PAGES_LIST_COUNT";
export const ADD_SELECTED_PAGE: string = "ADD_SELECTED_PAGE";
export const REMOVE_SELECTED_PAGE: string = "REMOVE_SELECTED_PAGE";
export const CLONE_PAGE_SAGA: string = "CLONE_PAGE_SAGA";
export const OPEN_CLONE_PAGE_DIALOG: string = "OPEN_CLONE_PAGE_DIALOG";
export const CLOSE_CLONE_PAGE_DIALOG: string = "CLOSE_CLONE_PAGE_DIALOG";
export const EXPORT_PAGE_SAGA: string = "EXPORT_PAGE_SAGA";
export const OPEN_EXPORT_PAGE_DIALOG: string = "OPEN_EXPORT_PAGE_DIALOG";
export const CLOSE_EXPORT_PAGE_DIALOG: string = "CLOSE_EXPORT_PAGE_DIALOG";
export const IMPORT_PAGE_SAGA: string = "IMPORT_PAGE_SAGA";
export const OPEN_IMPORT_PAGE_DIALOG: string = "OPEN_IMPORT_PAGE_DIALOG";
export const CLOSE_IMPORT_PAGE_DIALOG: string = "CLOSE_IMPORT_PAGE_DIALOG";
export const PAGES_LIST_BULK_DELETE_SAGA: string = "PAGES_LIST_BULK_DELETE_SAGA";
export const ACTIVATE_DOCUMENT_SAGA: string = "ACTIVATE_DOCUMENT_SAGA";
export const CHANGE_DOCUMENT_VERSION_STATUS: string = "CHANGE_DOCUMENT_VERSION_STATUS";
export const ARCHIVE_PAGE_SAGA: string = "ARCHIVE_PAGE_SAGA";
export const PAGES_LIST_SET_PAGE: string = "PAGES_LIST_SET_PAGE";
export const PAGES_LIST_SET_PAGE_SIZE: string = "PAGES_LIST_SET_PAGE_SIZE";
export const PAGES_LIST_SET_SORTING: string = "PAGES_LIST_SET_SORTING";
export const PAGES_LIST_SET_FILTERS: string = "PAGES_LIST_SET_FILTERS";
export const CHANGE_PAGE_TAGS: string = "CHANGE_PAGE_TAGS";

export const SET_BACKUP: string = "SET_BACKUP";
export const CLEAR_BACKUP: string = "CLEAR_BACKUP";
export const RESTORE_BACKUP: string = "RESTORE_BACKUP";

export const SET_ERRORS: string = "SET_ERRORS";

export const CHANGE_PAGE_NAME: string = "CHANGE_PAGE_NAME";
export const CHANGE_PAGE_TYPE: string = "CHANGE_PAGE_TYPE";
export const CHANGE_PAGE_URL: string = "CHANGE_PAGE_URL";
export const CHANGE_PAGE_PFT_TEMPLATE: string = "CHANGE_PAGE_PFT_TEMPLATE";

export const GET_PAGE_SAGA: string = "GET_PAGE_SAGA";
export const SET_PAGE: string = "SET_PAGE";
export const SET_PAGE_VERSION: string = "SET_PAGE_VERSION";
export const SAVE_PAGE_SAGA: string = "SAVE_PAGE_SAGA";
export const CREATE_PAGE_SAGA: string = "CREATE_PAGE_SAGA";
export const GET_PAGE_VERSION_PREVIEW: string = "GET_PAGE_VERSION_PREVIEW";

export const SET_MODIFIER_FORM_IS_EXPAND: string = "SET_MODIFIER_FORM_IS_EXPAND";
export const SET_MODIFIER_FORM_FIELDS: string = "SET_MODIFIER_FORM_FIELDS";
export const SAVE_MODIFIER_FORM_SAGA: string = "SAVE_MODIFIER_FORM_SAGA";

export const PAGE_MODIFIERS_SET_PAGE_MODIFIERS: string = "PAGE_MODIFIERS_SET_PAGE_MODIFIERS";
export const PAGE_MODIFIERS_RESET_PAGE_MODIFIERS: string = "PAGE_MODIFIERS_RESET_PAGE_MODIFIERS";
export const PAGE_MODIFIERS_ADD_PAGE_MODIFIERS: string = "PAGE_MODIFIERS_ADD_PAGE_MODIFIERS";
export const PAGE_MODIFIERS_REMOVE_PAGE_MODIFIERS: string = "PAGE_MODIFIERS_REMOVE_PAGE_MODIFIERS";
export const PAGE_MODIFIERS_SET_MODIFIER: string = "PAGE_MODIFIERS_SET_MODIFIER";

export const GET_ACCOUNT_LIST_SAGA: string = "GET_ACCOUNT_LIST_SAGA";
export const GET_ACCOUNT_SAGA: string = "GET_ACCOUNT_SAGA";
export const SAVE_ACCOUNT_SAGA: string = "SAVE_ACCOUNT_SAGA";

export const ACCOUNT_GENERAL_INFO_CHANGE_NAME: string = "ACCOUNT_GENERAL_INFO_CHANGE_NAME";
export const ACCOUNT_GENERAL_INFO_CHANGE_DOMAIN: string = "ACCOUNT_GENERAL_INFO_CHANGE_DOMAIN";

export const ACCOUNT_CHANGE_USERS: string = "ACCOUNT_CHANGE_USERS";

export const GET_REDIRECT_LIST_SAGA: string = "GET_REDIRECT_LIST_SAGA";
export const DELETE_REDIRECT_LIST_SAGA: string = "DELETE_REDIRECT_LIST_SAGA";
export const SET_REDIRECT_LIST: string = "SET_REDIRECT_LIST";
export const ADD_ACCOUNT_USER: string = "ADD_ACCOUNT_USER";
export const REMOVE_ACCOUNT_USER: string = "REMOVE_ACCOUNT_USER";
export const CHANGE_ACCOUNT_USER_ROLE: string = "CHANGE_ACCOUNT_USER_ROLE";

export const PAGE_VERSIONS_CHANGE_VERSION_HTML: string = "PAGE_VERSIONS_CHANGE_VERSION_HTML";
export const PAGE_VERSIONS_CHANGE_VERSION_CSS: string = "PAGE_VERSIONS_CHANGE_VERSION_CSS";
export const PAGE_VERSIONS_CHANGE_VERSION_JS: string = "PAGE_VERSIONS_CHANGE_VERSION_JS";
export const PAGE_VERSIONS_SET_PAGE_VERSIONS: string = "SET_VERSIONS";

export const SET_PAGE_RESOURCES: string = "SET_PAGE_RESOURCES";
export const ADD_PAGE_RESOURCE: string = "ADD_PAGE_RESOURCE";
export const REMOVE_PAGE_RESOURCE: string = "REMOVE_PAGE_RESOURCE";
export const REMOVE_ALL_PAGE_RESOURCE: string = "REMOVE_ALL_PAGE_RESOURCE";
export const DOWNLOAD_PAGE_RESOURCES_SAGA: string = "DOWNLOAD_PAGE_RESOURCES_SAGA";
export const DOWNLOAD_PAGE_RESOURCES_LOADING: string = "DOWNLOAD_PAGE_RESOURCES_LOADING";

export const GET_REDIRECT_SAGA: string = "GET_REDIRECT_SAGA";
export const SET_REDIRECT: string = "SET_REDIRECT";
export const CHANGE_REDIRECT_PAGE_URL: string = "CHANGE_REDIRECT_PAGE_URL";
export const CHANGE_REDIRECT_STATUS_CODE: string = "CHANGE_REDIRECT_STATUS_CODE";
export const CHANGE_REDIRECT_REDIRECT_URL: string = "CHANGE_REDIRECT_REDIRECT_URL";
export const SAVE_REDIRECT_SAGA: string = "SAVE_REDIRECT_SAGA";

export const SET_LOADING: string = "SET_LOADING";

export type PAGE_TYPES_TITLE_TYPE = "Page" | "Pft" | "Template" | "Custom";
export type PAGE_TYPES_KEY_TYPE = "page" | "pft" | "template" | "custom";

export type PAGE_TYPES_OBJECT = {
  pageTypeTitle: PAGE_TYPES_TITLE_TYPE;
  pageTypeKey: PAGE_TYPES_KEY_TYPE;
};

export const PAGE_TYPES: PAGE_TYPES_OBJECT[] = [
  { pageTypeTitle: "Page", pageTypeKey: "page" },
  { pageTypeTitle: "Pft", pageTypeKey: "pft" },
  { pageTypeTitle: "Template", pageTypeKey: "template" },
  { pageTypeTitle: "Custom", pageTypeKey: "custom" },
];

export const GET_LINKING_LIST_SAGA: string = "GET_LINKING_LIST_SAGA";
export const SET_LINKING_LIST: string = "SET_LINKING_LIST";
export const SET_LINKING_LIST_COUNT: string = "SET_LINKING_LIST_COUNT";
export const GET_LINKING_ITEM_SAGA: string = "GET_LINKING_ITEM_SAGA";
export const SET_LINKING_ITEM: string = "SET_LINKING_ITEM";
export const SET_LINKING_ITEM_NAME: string = "SET_LINKING_ITEM_NAME";
export const SET_LINKING_ITEM_TYPE: string = "SET_LINKING_ITEM_TYPE";
export const SET_LINKING_ITEM_TAGS_GENERATION: string = "SET_LINKING_ITEM_TAGS_GENERATION";
export const SET_LINKING_ITEM_TAGS_DISPLAY: string = "SET_LINKING_ITEM_TAGS_DISPLAY";
export const SET_LINKING_ITEM_TEMPLATE_CODE: string = "SET_LINKING_ITEM_TEMPLATE_CODE";
export const SET_LINKING_ITEM_SORTING: string = "SET_LINKING_ITEM_SORTING";
export const SET_LINKING_ITEM_WIDTH: string = "SET_LINKING_ITEM_WIDTH";
export const BULK_DELETE_LINKING_SAGA: string = "BULK_DELETE_LINKING_SAGA";
export const SAVE_LINKING_ITEM_SAGA: string = "SAVE_LINKING_ITEM_SAGA";
export const SET_LINKING_ITEM_ALGORITHM: string = "SET_LINKING_ITEM_ALGORITHM";
export const SET_LINKING_ITEM_HEIGHT: string = "SET_LINKING_ITEM_HEIGHT";
export const GET_LINKING_ITEM_HEIGHT_SAGA: string = "GET_LINKING_ITEM_HEIGHT_SAGA";
export const SET_LINKING_ITEM_USE_PAGINATION: string = "SET_LINKING_ITEM_USE_PAGINATION";

export const GET_ACCOUNT_MODULES_SAGA: string = "GET_ACCOUNT_MODULES_SAGA";
export const SET_ACCOUNTS_MODULES: string = "SET_ACCOUNTS_MODULES";

export const CHANGE_PAGE_TYPE_SAGA: string = "CHANGE_PAGE_TYPE_SAGA";

export const ACCOUNT_LIST: string = "ACCOUNT_LIST";
export const PAGES_LIST: string = "PAGES_LIST";
export const REDIRECT_LIST: string = "REDIRECT_LIST";
export const LINKING_LIST: string = "LINKING_LIST";

export const SAVE_REDIRECT_LOADING: string = "SAVE_REDIRECT_LOADING";
export const GET_REDIRECT_LOADING: string = "GET_REDIRECT_LOADING";
export const SAVE_LINKING_LOADING: string = "SAVE_LINKING_LOADING";
export const GET_LINKING_LOADING: string = "GET_LINKING_LOADING";

export const ACCOUNT_MODULES_LOADING: string = "ACCOUNT_MODULES_LOADING";
export const GET_PAGE_LOADING: string = "GET_PAGE_LOADING";
export const SAVE_PAGE_LOADING: string = "SAVE_PAGE_LOADING";
export const GET_PAGE_LIST_LOADING: string = "GET_PAGE_LIST_LOADING";
export const GET_ACCOUNT_LOADING: string = "GET_ACCOUNT_LOADING";
export const SAVE_ACCOUNT_LOADING: string = "SAVE_ACCOUNT_LOADING";
export const PAGE_EXPORTING_LOADING: string = "PAGE_EXPORTING_LOADING";
export const PAGE_IMPORTING_LOADING: string = "PAGE_IMPORTING_LOADING";
export const PAGE_CLONING_LOADING: string = "PAGE_CLONING_LOADING";
export const HEIGHT_LOADING: string = "HEIGHT_LOADING";
export const GET_PAGE_VERSION_PREVIEW_LOADING: string = "GET_PAGE_VERSION_PREVIEW_LOADING";
